import { LayoutProps, rankWith, uiTypeIs } from '@jsonforms/core';
import { ResolvedJsonFormsDispatch, withJsonFormsLayoutProps } from '@jsonforms/react';
import { useState } from 'react';
import { CaretDownOutLined, CaretUpOutLined } from '../../../../../icons/truWeb-icons';
import { currencyFormat } from '../../../../../utils/currency';
import { currencySymbol, getElements, getLabel } from '../../../../../utils/DynamicForms';
import { Tooltip } from '../../../../Tooltip';
import { useDynamicFormContext } from '../../../DynamicFormContext';
import { MarketQuote } from '../../../DynamicFormTypes';
import { Button } from '../../elements/Button';
import './style.scss'

export const QuotesCoveragesLayout = (props: LayoutProps) => {
  const [showCoverages, setShowCoverages] = useState(false);

  const { formData } = useDynamicFormContext();
  const quotes: MarketQuote[] | undefined = formData.quotes;

  const headers = formData.coverageLabels as string[];

  if (!quotes) return <p></p>;

  //@ts-ignore
  const singleValueCoverageMap: Record<SingleValueCoverage['value'], any> = {
    'N/A': <span>N/A</span>,
    NOT_SELECTED: <>Not Selected</>,
    SELECTED: 'Selected',
    CONTACT_UNDERWRITER: 'Contact Underwriter',

  };

  return (
    <div className="coverages">
      {
        formData.mustRequote && (
          <div className="coverages-warning">
            <span> <b>Warning!</b>{' '}</span>
            Coverage has changed for the quote.
            please re-quote
          </div>
        )
      }

      <div className="accordion">
        <div className="accordion-header" style={{ marginBottom: '25px' }}>
          <span className="title">{getLabel(props.uischema)}</span>
        </div>
        {getElements(props.uischema).map((element, index) => (
          <ResolvedJsonFormsDispatch
            {...props}
            uischema={element}
            key={index}
          />
        ))}
        <div className="accordion-header details-coverage" onClick={() => setShowCoverages(!showCoverages)}>
          <span className="title"> {showCoverages ? 'Close' : 'View details'} </span>
          <Button type="link" >
            {showCoverages ? (
              <CaretUpOutLined />
            ) : (
              <CaretDownOutLined />
            )}
          </Button>
        </div>
        {showCoverages ? (
          <div className="accordion-content animate__animated animate__fast animate__fadeIn">
            <div className="headers-col">
              {headers?.map((header, i) => (
                <div
                  className={`td ${i % 2 === 0 ? 'even' : 'odd'}`}
                  key={header}
                >
                  {header}
                </div>
              ))}
            </div>

            <div className="data-columns">
              {quotes.map((quote) => {
                return (
                  <div className="data-column" key={quote.id}>
                    {quote.coverage?.map((d, i) => (
                      <div className={`td ${i % 2 === 0 ? 'even' : 'odd'}`}>
                        {d.type === 'MultiValueCoverage' ? (
                          d.selected ? (
                            `$ ${d.selected}`
                          ) : (
                            <span className="disabled">N/A</span>
                          )
                        ) : d.value === 'SELECTED_WITH_EXCEPTION' ? (
                          <span >
                            <Tooltip title={d.exception!}>
                              {/* <PartiallyIncludedCoverageIcon fill="#7BB342" /> */}
                            </Tooltip>
                          </span>
                        ) : (
                          <span>
                            {singleValueCoverageMap[d.value] ?
                              singleValueCoverageMap[d.value] : currencyFormat(
                                d.value,
                                currencySymbol(
                                  formData,
                                  props.uischema.options?.dependencies
                                    ?.country?.[quote.market],
                                ),
                              ) ? currencyFormat(
                                d.value,
                                currencySymbol(
                                  formData,
                                  props.uischema.options?.dependencies
                                    ?.country?.[quote.market],
                                ),
                              ) : d.value}
                          </span>
                        )}
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export const QuotesCoveragesEntry = {
  tester: rankWith(1, uiTypeIs('QuotesCoveragesLayout')),
  renderer: withJsonFormsLayoutProps(QuotesCoveragesLayout),
};
